import { createSelector } from "@reduxjs/toolkit";

export const selectGalleryState = (state) => state.galleryState;
export const getAllImages = createSelector(selectGalleryState,(galleryState) => galleryState.images);